import { useTranslation } from 'react-i18next';
import { FormControl, InputLabel, MenuItem, Select, Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { GeopostPopup } from 'components/geopostPopup/GeopostPopup';
import { ISurveyMetadata } from 'features/seismic/models/interfaces/ISurveyMetadata';
import { SeismicMetadataContent } from './SeismicMetadataContent';

export function SeismicMetadataPopup ({ opened, setOpened, volumesMetadata }:Props){
    const { t } = useTranslation();
    const [ selectedVolumeToken, setSelectedVolumeToken ] = useState<string|null>(null);

    useEffect(() => {
        if (selectedVolumeToken === null && volumesMetadata.length > 1) {
            setSelectedVolumeToken(volumesMetadata[0].VolumeToken);
        }
    }, [volumesMetadata, selectedVolumeToken]);

    return (
        <GeopostPopup
            temporaryIgnoreFlexInContainer
            open={opened}
            title={t('metadataTitle')}
            onChangeOpen={value => setOpened(value)}
            overlay={false}
            height={650}
            width={650}
            padding={'20px'}
        >
            <Stack gap={2}>
                {
                    volumesMetadata.length > 1
                    &&
                    <FormControl sx={{width: '150px'}}>
                        <InputLabel id='metadata-volume-display-input-label'>Volume</InputLabel>
                        <Select label='Volume' labelId='metadata-volume-display-input-label' value={selectedVolumeToken} onChange={evt => setSelectedVolumeToken(evt.target.value)}>
                            {
                                volumesMetadata.map(volumeMetadata =>
                                    <MenuItem key={volumeMetadata.VolumeToken} value={volumeMetadata.VolumeToken}>{volumeMetadata.ProductName ?? volumeMetadata.DisplayName}</MenuItem>
                                )
                            }
                        </Select>
                    </FormControl>
                }
                {
                    volumesMetadata.map(volumeMetadata =>
                        <React.Fragment>
                            {
                                (volumeMetadata.VolumeToken === selectedVolumeToken || volumesMetadata.length === 1)
                                &&
                                <SeismicMetadataContent key={volumeMetadata.VolumeToken} surveyMetadata={volumeMetadata} />
                            }
                        </React.Fragment>
                    )
                }
            </Stack>
        </GeopostPopup>
    );
}

interface Props {
    opened: boolean;
    setOpened: (value: boolean) => void;
    volumesMetadata: ISurveyMetadata[];
}